module.exports = __webpack_public_path__ + "static/media/YF73_04.826ba891.jpg";